
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.RouteStatusWasChanged = {

  template: () => {
      return {
          tag: 'div',
          items: [
              {
                  items: [
                      {
                          items: [
                              {
                                  tag: 'label',
                                  items: [
                                      {
                                          tag: 'span',
                                          html: Monet.I18n.getResourcesByKey('route.status'),
                                          attributes: {
                                              class: 'i18nResource',
                                              id: 'span-routeStatus'
                                          },
                                      },
                                  ],
                                  attributes: {
                                      class: 'control-label',
                                      for: 'routeStatus'
                                  }
                              },
                              {
                                  items: [
                                      {
                                          tag: 'select',
                                          attributes: {
                                              multiple: 'true',
                                              id: 'routeStatus'
                                          }
                                      }
                                  ],
                                  attributes: {
                                      class: 'controls'
                                  }
                              }
                          ],
                          attributes: {
                              class: 'control-group'
                          }
                      },
                  ]
              }
          ]
      };
  },
  assignParameter: (jsonParam) => {
    const selectField = document.getElementById('routeStatus');
    const routeStatus = [
      {text: Monet.I18n.getResourcesByKey('event.check.routeStatusWasChanged.routeStatus.arrivedOrigin') , value: "ARRIVE_DESTINATION"},
      {text: Monet.I18n.getResourcesByKey('event.check.routeStatusWasChanged.routeStatus.completed'), value: "COMPLETE_ROUTE"},
      {text: Monet.I18n.getResourcesByKey('event.check.routeStatusWasChanged.routeStatus.departedOrigin'), value: "DEPART_ORIGIN"},
      {text: Monet.I18n.getResourcesByKey('event.check.routeStatusWasChanged.routeStatus.started'), value: "START_ROUTE" }
    ];

    const populateEmpty = () => {
      routeStatus.forEach((el) => {
        selectField.appendChild(new Option(el.text, el.value, false, false));
      });
    }

    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      let isSelected = false;
      let routeStatusSelected = jsonParam.status;

      if(routeStatusSelected && routeStatusSelected.length) {
        routeStatus.forEach((el) => {
          isSelected = routeStatusSelected.includes(el.value);
          selectField.appendChild(new Option(el.text, el.value, false, isSelected));
          isSelected = false;
        });
      } else {
       populateEmpty();
      };
    } else {
      populateEmpty();
    };
  },
  retrieveParameter: () => {
    const routeStatusSelected = $('#routeStatus').val();

    return JSON.stringify({
      status: routeStatusSelected || []
    });
  }
};
